import apiClient from "../../../../http-common";

// export const stateDropDown = async (id) => {
//   return await country.get(`/misc/state/${id}`, {
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   });
// };

export const stateDropDown = (countryId) => {
  return apiClient.post(`/dropdowns/getStateDropDown/${countryId}`);
};

// export const countryDropDown = async () => {
//   return await country.get(`/misc/country`, {
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   });
// };

export const countryDropDown = () => {
  return apiClient.post(`/dropdowns/getCountryDropDown`,)
}

// export const districtDropDown = async (stateId) => {
//   return await country.get(`/misc/district/${stateId}`, {
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   });
// };

export const districtDropDown = (stateId) => {
  return apiClient.post(`/dropdowns/getDistrictDropDown/${stateId}`);
};

export const unitDropDown = async () => {
  return await apiClient.get(`/misc/unit`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

// export const cityDropDown = async (talukaId) => {
//   return await country.get(`/misc/city/${talukaId}`, {
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   });
// };

export const cityDropDown = (districtId) => {
  return apiClient.post(`/dropdowns/getCityDropDown/${districtId}`);
};

// export const areaDropDown = async (cityId) => {
//   return await country.get(`/misc/area/${cityId}`, {
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   });
// };

export const areaDropDown = (cityId) => {
  return apiClient.post(`/dropdowns/getAreaDropDown/${cityId}`);
};

export const talukaDropDown = async (districtId) => {
  return await apiClient.post(`/dropdowns/getTalukaDropDown/${districtId}`);
};

export const getCountryDropdown = (searchString) => {
  return apiClient.post(`/country/searchStringCountry/${searchString}`);
};

export const getStateDropdown = (searchString) => {
  return apiClient.post(`/state/searchString/${searchString}`);
};

export const getDistrictDropdown = (searchString) => {
  return apiClient.post(`/district/searchString/${searchString}`);
};

export const getCityDropdown = (searchString) => {
  return apiClient.post(`/city/searching/${searchString}`);
};

export const getAreaDropdown = (searchString) => {
  return apiClient.post(`/area/searchString/${searchString}`);
};